import RaporTeacher from "../../../../../components/categories/siakad/laporan_adab/rapor_sync/HomeTeacher"
export default function Home() {
  
  return (
    <RaporTeacher />
  );
}